module.exports = __webpack_public_path__ + "img/back.a12dc1a0.svg";